import { Injectable } from '@angular/core';
import { ExportarDadosRequest } from '../../dto/exportacao/ExportarDadosDTO';
import axiosClient from '../../../shared/axios/axios-client';

@Injectable({
  providedIn: 'root',
})
export class ExportarDadosService {


  async exportarDados(body: ExportarDadosRequest): Promise<void> {
    try {
      const response = await axiosClient.post('/pessoa/exportar', body, {
        responseType: 'blob',
      });

      const disposition = response.headers['content-disposition'];
      const nomeArquivo = disposition
        ? disposition.split('filename=')[1]
        : `relatorio_saude_${new Date().getTime()}.csv`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      throw new Error(err?.response?.data?.message || 'Erro ao exportar dados');
    }
  }

}
